import {NoticeModel} from "@models/mapCMS.model";
import {NoticeInt} from "@interfaces/*";

export class MapCMS {

  mapCMS(response:NoticeInt[]):Array<NoticeModel> {
    return response.map(notice => new NoticeModel(notice));
  }


}
